module.exports = __webpack_public_path__ + "edge.png?690ece19dfa6b88db159ec6709d0c3bb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/point/edge.png
// module id = 937
// module chunks = 0